import React, { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Box, Typography, Grid, IconButton, useTheme, useMediaQuery } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ProductCard from '../components/ProductCard';
import PageAnimation from '../components/animations/PageAnimation';

function CategoryItemsPage({ products, isLoggedIn, orderItems, onUpdateCart, onGuestAction }) {
    const { category } = useParams();
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const categoryProducts = useMemo(() => {
        if (!products || !category) return [];
        return products.filter(p => (p.category || 'Uncategorized') === category);
    }, [products, category]);

    // Calculate order items by product for ProductCard
    const orderItemsByProduct = useMemo(() => {
        const map = {};
        Object.values(orderItems || {}).forEach(item => {
            const pid = item.product?.id;
            if (!pid) return;
            if (!map[pid]) map[pid] = [];
            map[pid].push(item);
        });
        return map;
    }, [orderItems]);

    return (
        <PageAnimation>
            <Container maxWidth="xl" sx={{ py: 3, minHeight: '80vh', pb: 10, bgcolor: '#fcfdfa' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 3,
                    position: 'sticky',
                    top: '75px',
                    zIndex: 100,
                    bgcolor: '#fcfdfa',
                    py: 1.5,
                    borderBottom: '1px solid rgba(0,0,0,0.05)',
                }}>
                    <IconButton onClick={() => navigate('/browse')} sx={{ mr: 1, bgcolor: '#f0f0f0', '&:hover': { bgcolor: '#e0e0e0' } }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', color: '#2e3b1f' }}>
                        {category}
                    </Typography>
                </Box>

                <Grid container spacing={isMobile ? 2 : 3}>
                    {categoryProducts.map((product) => (
                        <Grid item xs={6} sm={4} md={3} lg={2.4} key={product.id}>
                            <ProductCard
                                product={product}
                                orderItemsForProduct={orderItemsByProduct[product.id] || []}
                                onUpdateCart={onUpdateCart}
                                onGuestAction={onGuestAction}
                                isLoggedIn={isLoggedIn}
                                compact={isMobile}
                            />
                        </Grid>
                    ))}
                    {categoryProducts.length === 0 && (
                        <Grid item xs={12}>
                            <Typography variant="body1" sx={{ textAlign: 'center', mt: 4, color: 'text.secondary' }}>
                                No items found in this category.
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </Container>
        </PageAnimation>
    );
}

export default CategoryItemsPage;
